import { PurchaseDocumentsDataModel } from '@/shared/models/purchases.model';
import { DocsDataUIModel } from '@/shared/types/shared-types/documents.type';
import {
  PurchaseDocsUIModel,
  PurchaseDocumentsDataUIModel
} from '@/shared/ui-models/purchase.ui-model';

function mapToModel(docs: PurchaseDocumentsDataUIModel): PurchaseDocumentsDataModel {
  const purchaseDocs = {
    proofOfPayment: 'proofOfPayment',
    supplierNationalIdFront: 'supplierNationalIdFront',
    supplierNationalIdBack: 'supplierNationalIdBack'
  };

  const mapArrayProperty = (property: keyof PurchaseDocsUIModel) => {
    return docs[property]?.map((file) => file.file) ?? [];
  };

  const result: PurchaseDocumentsDataModel = {
    purchaseOrderId: docs.purchaseOrderId ?? ''
  };

  for (const [dataProperty, uiProperty] of Object.entries(purchaseDocs) as [
    keyof PurchaseDocsUIModel,
    keyof PurchaseDocsUIModel
  ][]) {
    if (docs[dataProperty]?.length) {
      result[uiProperty] = mapArrayProperty(dataProperty);
    }
  }

  return result;
}

function mapToUI(docs: PurchaseDocumentsDataModel): PurchaseDocumentsDataUIModel {
  const result: PurchaseDocsUIModel = {};
  Object.keys(docs).forEach((key) => {
    const docArray = docs[key as keyof PurchaseDocsUIModel];
    if (docArray && docArray.length) {
      result[key as keyof PurchaseDocsUIModel] = docArray.map((doc) => ({
        dataURL: doc.url,
        file: { name: doc.key?.split('/')[1] },
        id: doc.id,
        key: doc.key,
        documentType: doc.documentType,
        createdAt: doc.createdAt,
        createdByUser: doc.createdByUser
      })) as unknown as DocsDataUIModel[];
    }
  });
  return result;
}

const purchaseDocsMapper = { mapToModel, mapToUI };
export default purchaseDocsMapper;
